import { useEffect, useState } from "react";
import { client } from "../sdkAdapter";
import { useAuth } from "../context/AuthContext";
import PageBreadcrumb from "../components/common/PageBreadCrumb";
import UserMetaCard from "../components/UserProfile/UserMetaCard";
import UserInfoCard from "../components/UserProfile/UserInfoCard";
// import UserAddressCard from "../components/UserProfile/UserAddressCard";
import PageMeta from "../components/common/PageMeta";

export default function UserProfiles() {
  const { user, logout } = useAuth();
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    if (!user?.id) return;
    setLoading(true);
    try {
      const res = await client.getApiClientUserId({ id: String(user.id) }) as any;
      const data = res.data?.data || res.data;

      // Normalize data
      if (data) {
        if (!data.name && (data.first_name || data.last_name)) {
          data.name = `${data.first_name || ''} ${data.last_name || ''}`.trim();
        }


      }
      setProfile(data);
    } catch (err) {
      console.error("Failed to fetch profile:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      fetchProfile();
    } else {
      // No user ID available, stop loading
      setLoading(false);
    }
  }, [user]);

  if (loading && !profile) {
    return <div className="p-6 text-center">Loading Profile...</div>;
  }

  if (!user?.id) {
    return (
      <div className="p-6 text-center">
        <div className="mb-4 text-red-600 dark:text-red-400">
          Error: User ID not found. Please try logging in again.
        </div>
        <button
          onClick={logout}
          className="px-4 py-2 text-sm font-medium text-white transition-colors rounded-lg bg-brand-500 hover:bg-brand-600"
        >
          Logout
        </button>
      </div>
    );
  }

  return (
    <>
      <PageMeta
        title="Profile | Shoplattice Admin"
        description="User Profile Dashboard"
      />
      <PageBreadcrumb pageTitle="Profile" />
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        <h3 className="mb-5 text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-7">
          Profile
        </h3>
        <div className="space-y-6">
          <UserMetaCard user={profile} onUpdate={fetchProfile} />
          <UserInfoCard user={profile} />
          {/* <UserAddressCard /> */}
        </div>
      </div>
    </>
  );
}
